<template>
  <div class="home">

    <dashboard/>
  </div>
</template>

<script>
import dashboard from "@/components/Issuance.vue";

export default {
  name: "Issuance",
  components: {
    dashboard
  }
};
</script>
